import { Link } from "react-router-dom";
import downloadFileHandler from "helper/DownloadFile";
import { getFileIcon } from "helper/Common/CommonHelper";

const FilePreview = ({ files, onRemove, fileType }) => {
  if (fileType === "image") {
    return (
      <ul className="preview-uploaded-files d-flex flex-wrap gap-2">
        {files.map((file, index) => {
          return (
            <li
              key={index}
              className="file border border-gray rounded-8 overflow-hidden position-relative"
            >
              {onRemove && (
                <Link
                  to="#"
                  className="position-absolute top-0 end-0 m-1 bg-danger rounded-circle d-flex justify-content-center align-items-center p-1"
                  onClick={() => onRemove(index)}
                >
                  <span className="material-symbols-outlined text-white icon-sm">
                    delete
                  </span>
                </Link>
              )}

              <img
                src={file.path}
                alt="Uploaded"
                className="w-100 h-100 object-fit-cover object-center"
              />
            </li>
          );
        })}
      </ul>
    );
  } else if (fileType === "video") {
    return (
      <ul className="preview-uploaded-videos d-flex flex-wrap gap-2">
        {files.map((file, index) => (
          <li
            key={index}
            className="file border border-gray rounded-8 overflow-hidden position-relative"
            style={{ width: 220, height: 140 }}
          >
            <button
              type="button"
              className="position-absolute top-0 end-0 m-1 bg-danger rounded-circle d-flex justify-content-center align-items-center p-1 border-0"
              onClick={(e) => {
                e.stopPropagation();
                onRemove(index);
              }}
              style={{
                zIndex: 2, // Ensure button is above video
              }}
            >
              <span className="material-symbols-outlined text-white icon-sm">
                delete
              </span>
            </button>

            <video
              src={file.path}
              controls
              className="w-100 h-100 object-fit-cover object-center"
              style={{ background: "#000" }}
            >
              Your browser does not support the video tag.
            </video>
            <div className="position-absolute bottom-0 start-0 w-100 d-flex justify-content-between align-items-center px-2 py-1 bg-dark bg-opacity-50">
              <span
                className="text-white text-truncate"
                style={{ maxWidth: 120 }}
              >
                {file.name}
              </span>
            </div>
          </li>
        ))}
      </ul>
    );
  } else {
    return (
      <ul className="uploaded-files d-flex flex-wrap gap-3 p-0 m-0 mt-3">
        {files.map((file, index) => {
          return (
            <li
              className="file d-flex file_gap align-items-center px-3 py-2 border border-gray rounded-3 shadow-sm"
              key={index}
            >
              <span className="material-symbols-outlined text-primary">
                {getFileIcon(file.name)}
              </span>
              <p className="fw-medium text-truncate me-auto mb-0">
                {file.name}
              </p>
              <Link
                className="p-2 bg-light rounded-5 border border-gray-300"
                to="#"
                onClick={() => downloadFileHandler(file)}
              >
                <span className="d-block material-symbols-outlined icon-md text-gray-600 fw-medium">
                  download
                </span>
              </Link>
              <Link
                to="#"
                className="p-2 bg-light rounded-5 border border-gray-300"
                onClick={() => onRemove(index)}
              >
                <span className="d-block material-symbols-outlined icon-md text-gray-600 fw-medium">
                  delete
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    );
  }
};

export default FilePreview;
